// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=checkbox][data-v-32b4344c] {\n  margin-top: 15px;\n}\np[data-v-32b4344c] {\n  margin-bottom: 0;\n  margin-top: 15px;\n}", ""]);
// Exports
module.exports = exports;
